export default{
 /**
     * Find user device if is apple
     *
     * 
     */
    isUserApple(){
        let ag = /iPhone|iPad|iPod/i
        return ag.test(navigator.userAgent)
    },
     /**
     * Find user device if is android
     *
     * 
     */
    isUserAndroid(){
        let ag = /Android/i
        return ag.test(navigator.userAgent)
    }
}